import { render } from "./priceShow.vue?vue&type=template&id=60da8ca5&scoped=true"
import script from "./priceShow.vue?vue&type=script&lang=js"
export * from "./priceShow.vue?vue&type=script&lang=js"

import "./priceShow.vue?vue&type=style&index=0&id=60da8ca5&lang=less&scoped=true"
import "./priceShow.vue?vue&type=style&index=1&id=60da8ca5&lang=css"
import "./priceShow.vue?vue&type=style&index=2&id=60da8ca5&lang=less"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60da8ca5"]])

export default __exports__